import type { SocialPlatform } from "@/lib/nav";

export const SOCIAL_ICONS: Record<SocialPlatform, React.ReactNode> = {
  instagram: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M7 1.3c1.9 0 2.1 0 2.8.1.7 0 1 .1 1.3.2.3.1.6.3.8.5.3.3.4.5.5.8.1.3.2.6.2 1.3 0 .7.1.9.1 2.8s0 2.1-.1 2.8c0 .7-.1 1-.2 1.3-.1.3-.3.6-.5.8-.3.3-.5.4-.8.5-.3.1-.6.2-1.3.2-.7 0-.9.1-2.8.1s-2.1 0-2.8-.1c-.7 0-1-.1-1.3-.2-.3-.1-.6-.3-.8-.5-.3-.3-.4-.5-.5-.8-.1-.3-.2-.6-.2-1.3 0-.7-.1-.9-.1-2.8s0-2.1.1-2.8c0-.7.1-1 .2-1.3.1-.3.3-.6.5-.8.3-.3.5-.4.8-.5.3-.1.6-.2 1.3-.2.7 0 .9-.1 2.8-.1zM7 0C5.1 0 4.9 0 4.1.1c-.8 0-1.4.2-1.8.4-.5.2-.9.4-1.3.8-.4.4-.6.8-.8 1.3-.2.4-.3 1-.4 1.8C0 4.9 0 5.1 0 7s0 2.1.1 2.9c0 .8.2 1.4.4 1.8.2.5.4.9.8 1.3.4.4.8.6 1.3.8.4.2 1 .3 1.8.4.8 0 1 .1 2.9.1s2.1 0 2.9-.1c.8 0 1.4-.2 1.8-.4.5-.2.9-.4 1.3-.8.4-.4.6-.8.8-1.3.2-.4.3-1 .4-1.8 0-.8.1-1 .1-2.9s0-2.1-.1-2.9c0-.8-.2-1.4-.4-1.8-.2-.5-.4-.9-.8-1.3-.4-.4-.8-.6-1.3-.8-.4-.2-1-.3-1.8-.4C9.1 0 8.9 0 7 0zm0 3.4a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2zm0 5.9a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6zm4.6-6a.8.8 0 1 1-1.7 0 .8.8 0 0 1 1.7 0z" />
    </svg>
  ),
  youtube: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M13.7 3.7c-.2-.6-.6-1.1-1.2-1.2C11.4 2.2 7 2.2 7 2.2s-4.4 0-5.5.3c-.6.1-1 .6-1.2 1.2C0 4.8 0 7 0 7s0 2.2.3 3.3c.2.6.6 1.1 1.2 1.2 1.1.3 5.5.3 5.5.3s4.4 0 5.5-.3c.6-.1 1-.6 1.2-1.2.3-1.1.3-3.3.3-3.3s0-2.2-.3-3.3zM5.6 9.1V4.9L9.3 7 5.6 9.1z" />
    </svg>
  ),
  facebook: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M8.5 14V7.5h2.2l.3-2.6H8.5V3.3c0-.7.2-1.2 1.2-1.2h1.3V0H9.2C7.2 0 6 1.2 6 3.1v1.8H4V7.5h2V14h2.5z" />
    </svg>
  ),
  tiktok: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M10 0h-2v9.5c0 .8-.7 1.5-1.5 1.5S5 10.3 5 9.5 5.7 8 6.5 8c.2 0 .3 0 .5.1V6c-.2 0-.3 0-.5 0-1.9 0-3.5 1.6-3.5 3.5S4.6 13 6.5 13 10 11.4 10 9.5V5.3c.7.5 1.6.8 2.5.8V4.1c-1.4 0-2.5-1.1-2.5-2.5V0h0z" />
    </svg>
  ),
  linkedin: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M12.96 0H1.04C.47 0 0 .46 0 1.03v11.93C0 13.53.47 14 1.04 14h11.92c.58 0 1.04-.47 1.04-1.04V1.03C14 .46 13.54 0 12.96 0zM4.15 11.93H2.08V5.27h2.07v6.66zM3.11 4.36c-.66 0-1.2-.54-1.2-1.2 0-.67.54-1.2 1.2-1.2.66 0 1.2.53 1.2 1.2 0 .66-.54 1.2-1.2 1.2zM11.93 11.93h-2.07V8.7c0-.77-.02-1.76-1.07-1.76-1.07 0-1.24.84-1.24 1.7v3.29H5.48V5.27h1.99v.91h.03c.28-.52.95-1.07 1.96-1.07 2.1 0 2.49 1.38 2.49 3.17v3.65z" />
    </svg>
  ),
  x: (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
      <path d="M10.79 0h2.13L8.27 5.34l5.48 7.66H9.45L6.08 8.62 2.23 13H.1l4.98-5.71L0 0h4.41l3.05 4.05L10.79 0zm-.75 11.69h1.18L3.99 1.24H2.72l7.32 10.45z" />
    </svg>
  ),
};

export const SOCIAL_LABEL: Record<SocialPlatform, string> = {
  instagram: "Instagram",
  youtube: "YouTube",
  facebook: "Facebook",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  x: "X",
};
